import {useEffect, useState} from 'react';
import {get as localStorageGet, set as localStorageSet} from '@/utils/storageUtils';
import queryString from 'query-string';
import * as store from '@/store';
import sdk from '@/sdk';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {getMorphoService, serviceNames} from '@/rte/editor';

const IGNORE_QUERY = ['source'];
function getLocalCacheName() {
    const curUserGuid = sdk?.as?.user?.userGuid || '';
    return `cardLikeNewGuid_${curUserGuid}`;
}
function getCardLikeNewGuidVisible() {
    const LOCAL_STORAGE_KEY = getLocalCacheName();
    const cacheNewGuid = localStorageGet(LOCAL_STORAGE_KEY);
    const query = store.getUrlQuerySearch() || {};
    const queryKeys = Object.keys(query).filter(item => !IGNORE_QUERY.includes(item));
    if (!cacheNewGuid && queryKeys?.length <= 0) {
        return true;
    }
    return false;
}

export const CardMenuOperate = {
    show: 'show',
    hide: 'hide',
};
const DefaultNewGuidCardIndex = 1;
type ICardMenuOperate = typeof CardMenuOperate[keyof typeof CardMenuOperate];

function toggleCardMenuVisible(operate: ICardMenuOperate) {
    const slideService = getMorphoService(serviceNames.ISlideViewService);
    if (!slideService) {
        return;
    }
    const {MorphoAPI} = slideService?.editor || {};
    try {
        if (operate === CardMenuOperate.show) {
            const res = MorphoAPI?.toggleCardMenu(DefaultNewGuidCardIndex, true);
            store.setIsShowCardLikeNewGuid(res);
        } else {
            MorphoAPI?.toggleCardMenu(DefaultNewGuidCardIndex, false);
        }
    } catch (err) {
        console.log(err);
    }
}

export async function initCardMenuShow() {
    const show = getCardLikeNewGuidVisible();
    if (show) {
        toggleCardMenuVisible(CardMenuOperate.show);
    }
}

function useCardLikeNewGuid({
    index,
    isShow,
}: {
    index?: number;
    isShow: boolean;
}) {
    const LOCAL_STORAGE_KEY = getLocalCacheName();
    const [showNewGuid, setShowNewGuid] = useState(false);

    useEffect(() => {
        if (index === 1 && isShow) {
            setShowNewGuid(true);
            localStorageSet(LOCAL_STORAGE_KEY, 1);
        }
    }, [isShow, index, LOCAL_STORAGE_KEY]);

    function onCloseNewGuid() {
        setShowNewGuid(false);
        localStorageSet(LOCAL_STORAGE_KEY, 1);
        toggleCardMenuVisible(CardMenuOperate.hide);
    }

    return {onCloseNewGuid, showNewGuid};
}

export default useCardLikeNewGuid;
